<template>
  <div class="detail-row">
    <div class="icon-bar">
      <font-awesome-icon
        :icon="['fa', 'chart-bar']"
        title="View Data"
        @click="showdatepicker = false"
      />
      <font-awesome-icon
        :icon="['fa', 'th']"
        title="View Items"
        @click="
          showdatepicker = true;
          showitems = false;
        "
      />
      <font-awesome-icon
        :icon="['fa', 'list']"
        title="View Items"
        @click="
          showitems = true;
          showdatepicker = true;
        "
      />
    </div>
    <transition>
      <PendingChartView
        v-if="!showdatepicker"
        :selected_option="selected_option"
        @hidecharts="showdatepicker = true"
      ></PendingChartView>
      <ItemsTable
        v-if="showitems"
        :order_number="active_order"
        @show-chart="
          showitems = false;
          showdatepicker = false;
        "
        @show-picker="
          showitems = false;
          showdatepicker = true;
        "
      ></ItemsTable>
      <div v-if="showdatepicker" class="detail-row-datepicker">
        <h3>Package Risk Selector</h3>
        <div class="package-risk-matrix">
          <!-- top -->
          <div class="top">
            <div
              class="package-date-dates"
              v-for="(date, index) in StandardRisk"
              :key="'label' + index"
            >
              {{ epochToName(date.dates) }}
            </div>
          </div>
          <!-- Left -->
          <div class="left">
            <PackagingLabel>Standard </PackagingLabel>
            <PackagingLabel>Thermal Light </PackagingLabel>
            <PackagingLabel>Thermal Full </PackagingLabel>
          </div>
          <!-- Middle -->
          <div class="main">
            <TableCell
              @click.native="setActive(date)"
              :class="[{ 'active-cell': findActiveOrder(date) }, 'table-cell']"
              :selectedRisk="selected_option.risk"
              v-for="(date, index) in RiskMatrix"
              :shippingInstance="date"
              :key="date.kind + '_' + index"
            ></TableCell>
          </div>
          <!-- Right -->
          <div class="right">
            <div class="right-icons">
              <font-awesome-icon
                :icon="['fa', 'info-circle']"
                @click="showCalculationTooltip"
                title="Calculation Method"
              />
              <div
                tabindex="0"
                ref="tooltip"
                class="icon-calculation-tooltip"
                v-if="calculationTooltip"
                @blur="calculationTooltip = false"
              >
                <p>
                  Potential loss estimations are based on packaging costs, plus
                  the value of the items we predict not to be compliant plus the
                  model risk. Model risk takes into account the value of the
                  items we predict to be compliant times the 1% probability of
                  our prediction being incorrect (false positive rate).
                </p>
              </div>
            </div>
            <div class="right-information">
              <span>Total Value: {{ pricify(rowData.total_amount) }}</span>
              <span>
                Items at risk: {{ selected_option.not_ok }} /
                {{ selected_option.ok + selected_option.not_ok }}
              </span>
              <span>Prediction Confidence: 99%</span>

              <span
                >Value of Items at Risk:
                {{ pricify(selected_option.loss) }}</span
              >
              <span
                >Model Risk: {{ pricify(selected_option.model_risk) }}
              </span>
              <span>Packaging Cost: {{ packageCost }}</span>
              <span class="total-risk"
                >Total Potential Loss: {{ pricify(selected_option.risk) }}</span
              >
            </div>
          </div>
          <!-- Rightest -->
          <div class="buttons">
            <div
              class="package-risk-button"
              @click="$parent.$emit('accept', selected_option)"
            >
              Approve Shipment
            </div>
            <div
              class="package-risk-button"
              @click="setActive(rowData.suggestion)"
            >
              Reset to Suggestion
            </div>
            <div
              class="package-risk-button"
              @click="$parent.$emit('close', rowData)"
            >
              Close Selector
            </div>
          </div>
        </div>
      </div>
    </transition>
  </div>
</template>
<script>
import RiskData from "../../data/total_exposure_per_order.json";
import { TableFilters } from "../../mixins/TableFiters";
import PendingChartView from "./PendingChartView";
import TableCell from "./TableCell";
import PackagingLabel from "./PackagingLabel";
import ItemsTable from "./ItemsTable";

export default {
  name: "pending-detail-row",
  mixins: [TableFilters],
  components: {
    PendingChartView,
    TableCell,
    PackagingLabel,
    ItemsTable
  },
  props: {
    rowData: {
      type: Object,
      required: true
    },
    rowIndex: {
      type: Number
    }
  },
  data() {
    return {
      calculationTooltip: false,
      showdatepicker: true,
      showitems: false,
      active_order: this.rowData.order_number,
      selected_option: null,
      shippingOptions: [
        {
          title: "Standard Packaging",
          img: "standard.png",
          cost: "0.10 R",
          thermal: "10mHz",
          description:
            "This option provides the least temperature resistance and is ideal for short trips or non temperature sensitive product"
        },
        {
          title: "Thermal Packaging",
          img: "thermal.png",
          cost: "4 fr",
          thermal: "0.5mHz",
          description:
            "This is the typical transport option for temperature sensitive products. Provides some reslience against the weather, but has no assurance that the product will stay within the band"
        },
        {
          title: "Thermal+plus Guarantee",
          img: "thermalplus.png",
          cost: "25 fr",
          thermal: " - ",
          description:
            "The most expensive option, includes a provider guarantee that the product will stay within the temperature band."
        }
      ]
    };
  },
  created() {
    this.selected_option = this.rowData.suggestion;
  },
  methods: {
    setActive(shippingoption) {
      this.selected_option = shippingoption;
    },
    findActiveOrder(renderedOrder) {
      if (
        renderedOrder.dates === this.selected_option.dates &&
        renderedOrder.kind === this.selected_option.kind
      ) {
        this.selected_option = renderedOrder;
        return true;
      } else {
        return false;
      }
    },
    showCalculationTooltip() {
      this.calculationTooltip = true;
      this.$nextTick(() => {
        this.$refs.tooltip.focus();
      });
    }
  },
  computed: {
    packageCost() {
      switch (this.selected_option.kind) {
        case "standard":
          return "0.10 CHF";
        case "thermo-o-cool":
          return "4.00 CHF";
        default:
          return "25.00 CHF";
      }
    },
    RiskArray() {
      return RiskData.filter(x => x.order_number === this.active_order);
    },
    StandardRisk() {
      return this.RiskArray.filter(x => x.kind === "standard");
    },
    ThermalRisk() {
      return this.RiskArray.filter(x => x.kind === "thermo-o-cool");
    },
    GuaranteedRisk() {
      let array = this.StandardRisk;
      array = JSON.parse(JSON.stringify(array));
      return array.map(x => {
        x.kind = "thermo-cool-ultra";
        x.ok = x.ok + x.not_ok;
        x.not_ok = 0;
        x.risk = 25.0;
        x.loss = 0.0;
        return x;
      });
    },
    RiskMatrix() {
      return [
        ...this.StandardRisk,
        ...this.ThermalRisk,
        ...this.GuaranteedRisk
      ];
    }
  }
};
</script>

<style lang="scss">
@import "../../styles/_variables.scss";

.icon-bar {
  position: absolute;
  top: 30px;
  right: 30px;
  display: flex;
  > svg {
    margin-right: 10px;
    cursor: pointer;
    &:last-of-type {
      margin-right: 0;
    }
  }
}
.package-risk-matrix {
  display: grid;
  grid-gap: 5px;
  grid-template-columns: 1fr 1fr 1fr 1fr 1fr 1fr 2fr 1fr;
  grid-template-rows: 1fr 2fr 2fr 2fr;
  grid-template-areas: ". top top top top top right ." "left main main main main main right buttons" "left main main main main main right buttons" "left main main main main main right buttons";
}

.top {
  grid-area: top;
  display: flex;
  justify-content: space-around;
  align-items: center;
}

.main {
  grid-area: main;
  display: grid;
  grid-gap: 5px;
  grid-template-columns: repeat(5, 1fr);
}

.left {
  grid-area: left;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}

.right {
  grid-area: right;
  display: grid;
  grid-template-rows: 1fr 6fr;
  grid-gap: 3px;
  &-icons {
    display: flex;
    justify-content: flex-end;
    align-items: center;
    position: relative;
    svg {
      margin-right: 10px;
      cursor: pointer;
    }
  }
  &-information {
    border-radius: 5px;
    border: 1px solid $border;
    background-color: #fff;
    padding: 20px;
    font-size: 14px;
    display: flex;
    flex-direction: column;
    justify-content: space-around;
  }
}

.buttons {
  grid-area: buttons;
  display: grid;
  grid-template-rows: 1fr 1fr 1fr;
  grid-template-columns: 1fr;
  grid-gap: 5px;
}

.package-risk-button {
  border-radius: 5px;
  border: 1px solid darken($border, 40);
  background-color: #fff;
  padding: 5px;
  text-align: center;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
}

.table-cell {
  cursor: pointer;
}

.detail-row {
  min-height: 303px;
  position: relative;
  h3 {
    text-align: center;
    margin-bottom: 20px;
    margin-top: 10px;
    width: 70%;
  }
}

.detail-row-datepicker {
  padding-bottom: 20px;
}
.icon-calculation-tooltip {
  position: absolute;
  background-color: $modumBackground;
  padding: 20px;
  width: 320px;
  top: 30px;
  border-radius: 5px;
  &:focus {
    outline: none;
  }
  p {
    color: #fff;
    font-size: 13px;
    margin: 0;
    font-weight: 500;
  }
}
.small-info {
  font-size: 12px;
  position: relative;
  top: -8px;
}
.tablecell.active-cell {
  border: 1px solid darken($border, 40);
  box-shadow: 1px 1px 3px rgba(50, 50, 50, 0.3);
}
// Transition
.slide-leave-active,
.slide-enter-active {
  transition: 1s;
}
.slide-enter {
  transform: translate(100%, 0);
}
.slide-leave-to {
  transform: translate(-100%, 0);
}
</style>
